import $ from 'jquery';

import Swal from 'sweetalert2';

import {pseudoinputtrigger} from './partials/pseudo-input-count';

import './../scss/pages/_account.scss';


$(document).ready(function() {

  pseudoinputtrigger();

  $('.lemon_admin_save_adress').on('click',function(e){
    e.preventDefault()

    let isValid = true;
    let thisformgroup = $(this).closest('form');
    $('.form-control',thisformgroup).removeClass('is-invalid');


    $('.form-control',thisformgroup).each(function() {
      if ($(this).is(":invalid")) {
        $(this).closest('.form-group').find('.invalid-feedback')
        $(this).addClass('is-invalid')

        isValid = false;
      }
    });

    if (isValid) {
      
      
      $('.loading-loader').show();
      thisformgroup.find('.results').hide()
      var data = thisformgroup.serialize();
      $.ajax({
        type:		'POST',
        url:		ajax_url,
        data:		data,
        success:	function( response ) {
          console.log(response);
          if (response.success ) {
            window.location.href = response.u;
            
          } else {
            //thisformgroup.find('.error-results').show()
          }
          $('.loading-loader').hide();
        },
        error: function(response) {
          //console.log(data)
          $('.loading-loader').hide();
        }
      });   
    }
      
  })

})